import printComponent from './print.component';

let printOrdersModule = angular.module('printOrders', [])
    .config(($stateProvider) => {
        'ngInject';
        $stateProvider
            .state('printOrders', {
                url: '/print-orders',
                component: 'printOrders',
                params: {
                    id: null
                }
            })
    })
    .component('printOrders', printComponent)
    .name;

export default printOrdersModule;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/orders/print/index.js